import * as React from "react";
import styled from "styled-components";
import { Caption1, Caption2 } from "../styles/typography";

const TextAreaContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 4px;
`;

const TextAreaLabel = styled(Caption1)`
  color: rgb(${(props) => props.theme.colors.neutral200});
  margin-left: 8px;
  text-transform: uppercase;
`;

const StyledTextArea = styled.textarea`
  padding: 16px 24px;
  border: 2px solid
    rgb(
      ${(props) =>
        props.errorCondition
          ? props.theme.colors.error400
          : props.theme.colors.neutral100}
    );
  border-radius: 8px;
  font-family: "Inter";
  font-size: 19px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
  min-height: 140px;
  resize: vertical;
  color: rgb(${(props) => props.theme.colors.neutral600});
  box-sizing: border-box;

  :focus {
    border: 2px solid
      rgb(
        ${(props) =>
          props.errorCondition
            ? props.theme.colors.error400
            : props.theme.colors.neutral600}
      );
    outline: none;
  }

  ::placeholder {
    color: rgb(${(props) => props.theme.colors.neutral200});
  }
`;

const ErrorMessage = styled(Caption2)`
  color: rgb(${(props) => props.theme.colors.error400});
  margin: 2px 4px;
`;

const HintText = styled(Caption2)`
  color: rgb(
    ${(props) =>
      props.hintError
        ? props.theme.colors.error400
        : props.theme.colors.neutral200}
  );
  margin: 2px 4px;
  text-align: right;
`;

const TextArea = (props) => {
  return (
    <TextAreaContainer style={props.style}>
      {props.label && <TextAreaLabel>{props.label}</TextAreaLabel>}
      <StyledTextArea
        placeholder={props.placeholder}
        onChange={props.onValueChange}
        value={props.value}
        name={props.name}
        onBlur={props.onBlur}
        errorCondition={props.errorCondition}
        disabled={props.disabled}
        id={props.id}
      />
      {props.errorCondition && props.errorMessage ? (
        <ErrorMessage>{props.errorMessage}</ErrorMessage>
      ) : props.hintText ? (
        <HintText hintError={props.hintError}>{props.hintText}</HintText>
      ) : null}
    </TextAreaContainer>
  );
};

export default TextArea;
